import React from 'react'

function GreenTick() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10.211" viewBox="0 0 16 10.211">
      <path fill="#209684" d="M5.959 10.211L16 0h-2.594L5.959 7.522 2.645 4.145H0z" data-name="Subtraction 432"></path>
    </svg>
  )
}

export default GreenTick
